module.exports = __webpack_public_path__ + "img/tubiao-31.cd8b40ee.png";